<lib-itinerary-of-services-library [primaryData]="primaryData" (dialogClose)="onDialogClose()" style="width:100%">
</lib-itinerary-of-services-library>
